import { throwApiError } from 'src/packages/errors';

import type { AxiosInstance } from 'axios';

export class SyncWithDbApi {
  private readonly gatewayAgent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.gatewayAgent = agent;
  }

  async syncWithDb(wellIds: number[]) {
    try {
      await this.gatewayAgent.post('/api/v1/gostream/migration/migrate/wells', wellIds);
    } catch (e) {
      throwApiError(e);
    }
  }
}
